/**
 * @typedef {import('../contracts/access.js').AccessData} AccessData
 */

/** @type {AccessData} */
const MOCK_ACCESS = {
  roles: [
    {
      key: 'admin',
      permissions: [
        'users.view', 'users.edit', 'users.delete',
        'content.pages.view', 'content.pages.edit',
        'content.media.view', 'content.media.upload',
        'orders.view', 'orders.edit',
        'settings.view', 'settings.edit',
      ],
    },
  ],
  userOverrides: {
    additions: [],
    removals: [],
  },
};

/**
 * Creates a mock access adapter that returns static role/permissions data.
 */
export function createMockAccessAdapter() {
  /**
   * @param {AbortSignal} [signal]
   * @returns {Promise<AccessData>}
   */
  function fetchAccess(signal) {
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => resolve({
        roles: MOCK_ACCESS.roles.map(r => ({ ...r, permissions: [...r.permissions] })),
        userOverrides: {
          additions: [...MOCK_ACCESS.userOverrides.additions],
          removals: [...MOCK_ACCESS.userOverrides.removals],
        },
      }), 50);
      signal?.addEventListener('abort', () => {
        clearTimeout(timer);
        reject(new DOMException('Aborted', 'AbortError'));
      });
    });
  }

  return { fetchAccess };
}
